import type { communications as en } from '@/i18n/locales/en/communications';
import type { Translation } from '@/i18n/types';

export const communications: Translation<typeof en> = {
  page: {
    title: 'Comunicación',
    lead: 'Redacte y programe notificaciones para {{company}}.',
    noScope: 'Seleccione una empresa para ver su comunicación.',
    forbidden: 'No tiene permiso para ver la comunicación de esta empresa.',
  },
  composer: {
    title: 'Nueva notificación',
    titleField: 'Título',
    message: 'Mensaje',
    category: 'Categoría',
    audience: 'Público objetivo',
    date: 'Fecha',
    time: 'Hora',
    callToAction: 'Llamada a la acción',
    quietHours: 'Respetar horas de silencio',
    quietHoursHint: 'Retrasar la entrega fuera de 08:00–20:00.',
    submit: 'Guardar como borrador',
    schedule: 'Programar',
    send: 'Enviar ahora',
  },
  categories: {
    algemeen: 'General',
    veiligheid: 'Seguridad',
    evenement: 'Evento',
    vitaliteit: 'Vitalidad',
    hr: 'RR. HH.',
  },
  audiences: {
    iedereen: 'Todos',
    management: 'Dirección',
    per_afdeling: 'Por departamento',
    per_locatie: 'Por ubicación',
  },
  status: {
    concept: 'Borrador',
    ingepland: 'Programado',
    verzonden: 'Enviado',
  },
  log: {
    title: 'Registro de envíos',
    empty: 'Todavía no hay comunicación.',
    columns: {
      message: 'Mensaje',
      category: 'Categoría',
      reach: 'Alcance',
      openRate: 'Tasa de apertura',
      status: 'Estado',
    },
  },
  actions: {
    new: 'Nueva notificación',
    cancel: 'Cancelar',
    markScheduled: 'Marcar como programado',
    markSent: 'Marcar como enviado',
  },
};
